// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"styles_dashboardContainer__5pDor"};